/* eslint-disable react-hooks/exhaustive-deps */
import { COLOR_TYPE } from '@libs/interfaces/layouts'
import { useEffect, useState } from 'react'
import IScalarForm from '../interface/IScalarForm'
import Scalar from './Scalar'
import ColorExample from './color/ColorExample'
import GradientExample from './color/GradientExample'
import TypeButton from './color/TypeButton'
import PantoneExample from './color/PantoneExample'

const Color = ( props: IScalarForm ): JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<ColorEnabled {...props} isHideInput={false} />}
        desabledForm={<ColorDisabled {...props} />}
    /> 
} 
export default Color

export const ColorEnabled = ({isHideInput, ...props}: any) : JSX.Element =>  {

    const getTypeByColor = (color: string) : COLOR_TYPE => { 
        if( color.indexOf( "-gradient" ) > -1  ) {
            return COLOR_TYPE.GRADIENT
        }
        if( color.indexOf( "var(" ) > -1 || color.indexOf( "transparent" ) > -1 ) {
            return COLOR_TYPE.PANTONE
        }
        return COLOR_TYPE.PLAIN
    }
    const getType = () => {
        return props.colorType || props.onlyPlainColor 
            ? 
            COLOR_TYPE.PLAIN 
            :
            props.onlyPantoneColor
                ?
                COLOR_TYPE.PANTONE
                :
                props.onlyGradientColor 
                    ? 
                    COLOR_TYPE.GRADIENT 
                    :
                    getTypeByColor( props.value?.toString() || "" )
    }
    const [colorType, setColorType] = useState<COLOR_TYPE>(
        getType()
    )
    const onChangeType = () => {
        const next = () => {
            return {
                [ COLOR_TYPE.GRADIENT ] : COLOR_TYPE.PLAIN,
                [ COLOR_TYPE.PLAIN ] : COLOR_TYPE.PANTONE,
                [ COLOR_TYPE.PANTONE ] : COLOR_TYPE.GRADIENT,
            }
        }
        const nx =  next()[ colorType ] 
        setColorType( nx )
    }
    const onColor = (color: any) => {  
        if( props.onChange) props.onChange( color, props.field, "" )
    } 
    let scalar: JSX.Element =<></>

    useEffect(() => {
        setColorType( getType() )
    }, [ props.value ])

    switch(colorType) {
        case COLOR_TYPE.GRADIENT:
            scalar = <GradientExample value={props.value} field={props.field}  onChange={onColor} />
            break
        case COLOR_TYPE.PANTONE:
            scalar = <PantoneExample value={props.value} field={props.field} onChange={onColor} />
            break
        case COLOR_TYPE.PLAIN:
        default:
            scalar = <ColorExample value={props.value} field={props.field} onChange={onColor} isHideInput={isHideInput} />
    }
    return <div className={ `d-flex w-100 align-items-start ${props.className ? props.className : ""}` }>  
        <div className="d-flex flex-grow-100">
            {scalar}
        </div>
        <TypeButton 
            onlyPlainColor={props.onlyPlainColor} 
            onlyPantoneColor={props.onlyPantoneColor} 
            onlyGradientColor={props.onlyGradientColor} 
            colorType={ colorType } 
            onChangeType={onChangeType}
        /> 
    </div>
}
export const ColorDisabled = (props: IScalarForm) : JSX.Element => {
    return <div 
        className={`pe-color-picker-example ${props.className}`} 
        style={{ backgroundColor: props.value }} 
    /> 
}





